<template>
  <div class="container">
    <div class="content">
      <div style="position: relative;">
        <img width="100%" src="@/assets/join.jpg" alt="banner" style="display: block;" />
        <div class="banner-text">{{lang.careers}}</div>
      </div>

      <div class="searchstart" @click="goSearch">
        <Search  />
        <div class="opsfil">
          <SelectPop :text="lang.join.posiType" />
          <SelectPop :text="lang.join.city" />
          <SelectPop :text="lang.join.type" />
        </div>
      </div>

      <div class="list">
        <template v-for="(item,i) in list">
          <Item :key="i" :row="item" />
        </template>
      </div>

      <page-footer></page-footer>
    </div>
  </div>
</template>
<script>
import mapStore from "@/mixins/mapStore";
import Item from "./search/Item";
import Search from "./search/Search";
import SelectPop from "./search/SelectPop";
import { GetPositionList } from "@/api/api";
export default {
  components: { Item, Search, SelectPop },
  mixins: [
    mapStore("", {
      getters: ["lang", "china"],
    }),
  ],
  data() {
    return {
      pageIndex: 0,
      pageSize: 10,
      total: 0,
      list: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {

    goSearch(){
      this.$router.push({
        path: "/join/search"
      })
    },
    
    getData(kw) {
      var { pageIndex, pageSize } = this;
      GetPositionList({ pageIndex, pageSize, name: kw, type:-1 }).then((res) => {
        console.log(res);
        var { code, data } = res;

        if (code === 0) {
          var { dataCount } = data || {};
          var list = data.data || [];
          this.list = list;
          this.total = dataCount;
        }
      });
    },
  },
};
</script>
<style lang="less">
.img {
  vertical-align: middle;
}
.top-panel {
  position: fixed;
  top: 0;
  width: 100%;
}
.content {
  padding-top: 52px;
}
.item {
  margin-bottom: 15px;
  box-shadow: rgb(230, 230, 230) 1px 1px 10px;
}

.searchstart {
  position: relative;
  height: 90px;
  border-bottom: 10px solid #D8DCDF;
  .search {
    position: absolute;
    width: 100%;
    top: -43px;
    .cancle,
    .clear {
      display: none !important;

    }
  }
  .opsfil {
    padding: 0 20px;
    padding-top: 45px;
    display: flex;
    >div {
      margin-right: 10px;
    }
  }
}
</style>